import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ProductMediaFields, { saveProductMedia } from './ProductMediaFields';
import { productsApi } from './api';
export default function ProductMediaDialog({ product, onHide, onUpdated, isAdmin }) {
    const [current, setCurrent] = useState(null);
    const [image, setImage] = useState(undefined);
    const [upcs, setUpcs] = useState([]);
    const [knownUpcs, setKnownUpcs] = useState([]);
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        let active = true; setCurrent(null); setImage(undefined); setError('');
        if (product) productsApi(product._id).then(data => { if (active) { setCurrent(data); setUpcs(data.upcs); setKnownUpcs(data.upcs); } }).catch(e => { if (active) setError(e.message); });
        return () => { active = false; };
    }, [product]);
    async function save(event) {
        event.preventDefault(); if (saving) return;
        setSaving(true); setError('');
        try {
            await saveProductMedia(current, { image, upcs, removedUpcs: knownUpcs.filter(code => !upcs.includes(code)) }, productsApi, updated => { setCurrent(updated); setKnownUpcs(previous => [...new Set([...previous, ...updated.upcs.filter(code => upcs.includes(code))])]); onUpdated(updated); });
            onHide();
        } catch (e) { setError(`${e.message} Los cambios que ya se guardaron se conservan. Puedes corregir y reintentar; si el producto cambió, cierra y vuelve a abrir la ficha.`); }
        finally { setSaving(false); }
    }
    return <Dialog header={product ? `Imagen y códigos · ${product.name}` : 'Imagen y códigos'} visible={Boolean(product)} onHide={() => !saving && onHide()} style={{ width: '36rem', maxWidth: '95vw' }}>
        {error && <p role="alert">{error}</p>}
        {!current && !error && <p>Cargando ficha…</p>}
        {current && <form onSubmit={save}>
            <ProductMediaFields image={image} currentImage={current.imageUrl} upcs={upcs} onImage={setImage} onUpcs={setUpcs} disabled={saving || !isAdmin} />
            {isAdmin && <Button label="Guardar imagen y códigos" type="submit" loading={saving} disabled={saving} />}
            <Button label="Cerrar" type="button" className="p-button-text" disabled={saving} onClick={onHide} />
        </form>}
    </Dialog>;
}
